
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"9","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.117 7.195c-.302.328-.614.565-.937.711a2.556 2.556 0 01-1.078.219c-.657 0-1.214-.13-1.672-.39a2.537 2.537 0 01-1.032-1.102c-.224-.474-.336-1.026-.336-1.656 0-.678.139-1.282.415-1.813.276-.531.7-1.031 1.273-1.5l-.031-.078h-.977c-.276 0-.5.029-.672.086a1.421 1.421 0 00-.484.273 3.473 3.473 0 00-.5.54l-.484-.422c.343-.47.62-.795.828-.977.213-.188.45-.326.71-.414.266-.094.605-.14 1.016-.14h9.727v1.054h-2.39l-.024.078c.604.505 1.039 1.016 1.304 1.531.271.516.407 1.115.407 1.797 0 .709-.136 1.3-.407 1.774-.27.468-.635.812-1.093 1.03a3.565 3.565 0 01-1.555.329 2.63 2.63 0 01-1.102-.234 2.71 2.71 0 01-.906-.696zm2.235-5.61H4.89a3.966 3.966 0 00-1 1.47c-.22.562-.329 1.218-.329 1.968 0 .823.13 1.443.391 1.86.26.416.64.625 1.14.625.496 0 .842-.151 1.04-.453.203-.308.304-.792.304-1.453V3.21h1.368V5.6c0 .485.05.865.148 1.141.1.276.245.474.438.594.192.115.445.172.757.172.282 0 .534-.078.758-.235.23-.156.414-.419.555-.789.146-.375.219-.862.219-1.46 0-.75-.104-1.399-.313-1.946a4.056 4.056 0 00-1.015-1.492z","fill":"currentColor"}})])
          )
        }
      }
    